module.exports = __webpack_public_path__ + "static/media/imageColaborador2.32307f53.png";